import { render, staticRenderFns } from "./eco.vue?vue&type=template&id=0fe6b49d&"
import script from "./eco.vue?vue&type=script&lang=js&"
export * from "./eco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports